import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer"
import _ from 'lodash';
import { TransactionResp } from '@/types/transaction.type';
import moment from 'moment-timezone';
import { useTranslation } from "react-i18next";

// Font.register({
//   family: 'Calibri', fonts: [
//     { src: FontCalibri },
//     { src: FontCalibriI, fontStyle: 'italic' },
//     { src: FontCalibriB, fontWeight: 'bold' },
//     { src: FontCalibriBI, fontStyle: 'italic', fontWeight: 'bold' },
//   ]
// })

const styles = StyleSheet.create({
    textUpperCase: {
        textTransform: 'uppercase'
    },
    textBold: {
        fontWeight: 'bold'
    },
    textItalic: {
        fontSize: 'italic'
    },
    textUnderline: {
        textDecoration: 'underline'
    },
    textAlignCenter: {
        textAlign: 'center'
    },
    page: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 20,
        marginRight: 20
    },
    body: {
        // fontFamily: "Calibri",
    },
    content: {
        fontSize: 10,
        paddingTop: 65,
        paddingLeft: 55,
        paddingRight: 125,
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
    },
    table: {
        // fontFamily: "Calibri",
        fontSize: 12,
    },
    cell: {
        padding: 5,
        justifyContent: 'center',
        alignItems: 'center',
        borderRight: '1 solid black',
    },
    borderTop: {
        borderTop: '1 solid black',
    },
    borderBottom: {
        borderBottom: '1 solid black',
    },
    mt20: {
        marginTop: 20,
    },
    mt10: {
        marginTop: 10,
    },
    mb20: {
        marginBottom: 5,
    },
    headerContent: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 20,
    },
    pt20: {
        paddingTop: 10
    },
    flex1: {
        flex: 1
    },
    flex2: {
        flex: 2
    },
    borderLeft: {
        borderLeft: '1 solid black'
    },
    fontSize8: {
        fontSize: 8
    },
    fontSize10: {
        fontSize: 10
    },
    fontSize14: {
        fontSize: 14
    },
    textCenter: {
        textAlign: 'center'
    },
});

interface PdfProps {
    data: TransactionResp[]
    totalDeposit: number
    totalWithdraw: number
}

export default function PdfTransaction(props: PdfProps) {
    const { data, totalDeposit, totalWithdraw } = props
    const { t } = useTranslation()

    return (
        <Document>
            <Page object-fit="fill" size="A4" orientation="landscape">
                <View style={styles.page}>
                    <View style={[styles.headerContent, styles.textBold, styles.fontSize10]}>
                        <Text style={styles.mb20}>Total Deposit: {totalDeposit.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2})}</Text>
                        <Text>Total Withdraw: {totalWithdraw.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2})}</Text>
                    </View>
                    <View style={styles.body}>
                        <View style={styles.table}>
                            <View style={[styles.row, styles.textBold, styles.borderTop, styles.borderBottom, styles.mt20, styles.fontSize10]} fixed>
                                <View style={[styles.cell, styles.flex2, styles.borderLeft]}>
                                    <Text>{t("transaction.business_unit")}</Text>
                                </View>
                                <View style={[styles.cell, styles.flex2]}>
                                    <Text>{t("transaction.category")}</Text>
                                </View>
                                <View style={[styles.cell, styles.flex1]}>
                                    <Text>{t("transaction.date")}</Text>
                                </View>
                                <View style={[styles.cell, styles.flex2]}>
                                    <Text>{t("form.description")}</Text>
                                </View>
                                <View style={[styles.cell, styles.flex2]}>
                                    <Text>{t("transaction.transaction_code")}</Text>
                                </View>
                                <View style={[styles.cell, styles.flex2]}>
                                    <Text>{t("transaction.deposit")}</Text>
                                </View>
                                <View style={[styles.cell, styles.flex2]}>
                                    <Text>{t("transaction.withdraw")}</Text>
                                </View>
                            </View>

                            {data.map((item, i) => {
                                const isBreakPage = i > 0 && i % 18 === 0
                                return (
                                    <View style={[styles.row, styles.borderBottom, styles.fontSize8]} break={isBreakPage} key={i}>
                                        <View style={[styles.cell, styles.flex2, styles.borderLeft]}>
                                            <Text>{item?.business_unit_name}</Text>
                                        </View>
                                        <View style={[styles.cell, styles.flex2]}>
                                            <Text>{item?.transaction_type_name}</Text>
                                        </View>
                                        <View style={[styles.cell, styles.flex1]}>
                                            <Text>{item?.date ? moment(item?.date).format("MMM DD YYYY") : ""}</Text>
                                        </View>
                                        <View style={[styles.cell, styles.flex2]}>
                                            <Text>{item?.description}</Text>
                                        </View>
                                        <View style={[styles.cell, styles.flex2]}>
                                            <Text>{item?.unit_code_name}</Text>
                                        </View>
                                        <View style={[styles.cell, styles.flex2]}>
                                            <Text>{item?.amount_deposit.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2})}</Text>
                                        </View>
                                        <View style={[styles.cell, styles.flex2]}>
                                            <Text>{item?.amount_withdraw.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 2})}</Text>
                                        </View>
                                    </View>
                                )
                            })}
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}